import { PRODUCT_NAME } from "@amtana/i18n/catalog";

import type { UseCaseWords } from "./use-case-page.ts";

// /es/use-cases/competitor-followers, in Spanish. The product reads an account's followers and its
// following, and no other source (D1151). On a credit it says what the Terms say (D1153).
export const COMPETITOR_FOLLOWERS_WORDS_ES: UseCaseWords = {
  linkLabel: "Seguidores de la competencia",
  title: "Leads de seguidores de la competencia",
  description: `Consigue leads de seguidores de la competencia: ${PRODUCT_NAME} lee los perfiles públicos entre los seguidores de una cuenta, y tú filtras y exportas la lista.`,
  keyphrase: "leads de seguidores de la competencia",
  heroTitle: "Consigue leads de seguidores de la competencia",
  lede: `Nombra una cuenta que tus compradores siguen. ${PRODUCT_NAME} lee a sus seguidores y deja los perfiles públicos en una lista que puedes filtrar y exportar.`,
  steps: [
    {
      eyebrow: "1 · Nombra",
      title: "Elige la cuenta",
      description: "Una que tus compradores ya siguen.",
    },
    {
      eyebrow: "2 · Lee",
      title: `${PRODUCT_NAME} lee a sus seguidores`,
      description: "Solo perfiles públicos. 1 crédito lee 1 perfil público.",
    },
    {
      eyebrow: "3 · Usa",
      title: "Filtra y exporta",
      description: "Filtra por tipo o contacto y descarga un CSV.",
    },
  ],
  sample: [
    {
      name: "Panadería de ejemplo",
      username: "ejemplo.panaderia",
      type: "business",
      email: "ho•••@example.com",
      phone: "+00 ••• ••• 000",
    },
    {
      name: "Estudio de ejemplo",
      username: "ejemplo.estudio",
      type: "business",
      email: "in•••@example.com",
      phone: null,
    },
    {
      name: "Persona de ejemplo",
      username: "ejemplo.persona",
      type: "personal",
      email: null,
      phone: null,
    },
    {
      name: "Clínica de ejemplo",
      username: "ejemplo.clinica",
      type: "business",
      email: null,
      phone: "+00 ••• ••• 000",
    },
  ],
  get: [
    "Una lista de los perfiles públicos entre los seguidores de la cuenta.",
    "El nombre, el usuario y el tipo de cada perfil, negocio o personal.",
    "El email o el teléfono que el perfil muestre en público.",
    "Filtros por tipo y contacto, y exportación a CSV.",
  ],
  limit: "Las cuentas privadas no se leen, y no todo perfil público muestra un contacto.",
  questions: [
    {
      question: "¿Lee cuentas privadas?",
      answer: `No. ${PRODUCT_NAME} lee solo perfiles públicos.`,
    },
    {
      question: "¿Todos los perfiles tendrán un email?",
      answer: "No. Algunos perfiles públicos muestran un email o un teléfono, y otros ninguno.",
    },
    {
      question: "¿Qué compra un crédito?",
      answer: "1 crédito lee 1 perfil público, con o sin contacto. Las cuentas privadas no se leen.",
    },
    {
      question: "¿De dónde salen los contactos?",
      answer: "De lo que cada cuenta publica en su propio perfil público.",
    },
    {
      question: "¿Puede leer las cuentas que alguien sigue?",
      answer: "Sí. Un análisis lee los seguidores de una cuenta o las cuentas que sigue.",
    },
  ],
  ctaTitle: "Empieza con una cuenta",
  ctaDescription: "Tu primer análisis corre con créditos gratis.",
};
